import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {Input} from 'reactstrap';
import jwt_decode from 'jwt-decode';
import {Link, Redirect} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import Countdown from 'react-countdown';
import invLogo from "../assets/img/innoviti-logo.png";
import {parse} from "query-string";

import leftBackImg from "../assets/img/landing_back.png";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
const queryString = require('query-string');

class ActivateAccount extends Component {
   constructor() {
      super();


      this.state = {
          loading :false,
          loading1 :false,
          form_view :false,
          err_message :false,
          email: '',
          password: '',
          errors:'',
          OTP: false,
          OTPVal:'',
          uArray:[],
          mobile:'',
          countdown: '',
          response_status:'',
          rcv_otp_type:'',
          subgroup_id:'',
          maskedEmail:''

      };
       this.onChange = this.onChange.bind(this);
       this.onSubmit = this.onSubmit.bind(this);
       this.validator = new SimpleReactValidator();
       this.validator1 = new SimpleReactValidator();
   }
   componentDidMount() {
        this.check_activation();
       // var dt1 = 1584987640945;
       // var d = new Date();
       // var n = d.getTime();
       // alert(n);
       // var diffInMillis = n - dt1;
       // var isLessThan1Hour = diffInMillis /( 60 * 60 * 1000);
       // alert(isLessThan1Hour);
       // alert(diffInMillis);
   }

   check_activation() {
       var parsed = queryString.parse(this.props.location.search);
       let uid = parsed.uid;
       //alert(uid);
       this.setState({
           loading1 :true,
       })
       axios.get(config.get('API_URL')+'/users/activate-account/',{
           params: {
               user_id: uid,
           }
       }).then(response => {

           this.setState({
               loading1: false,
               response_status: response.data.status
           })
           if (response.data.status == 'ok'){
           if(response.data.email)
          {
            var maskid = "";
            var myemailId =  response.data.email;
            var prefix= myemailId .substring(0, myemailId .lastIndexOf("@"));
            var postfix= myemailId .substring(myemailId .lastIndexOf("@"));

            for(var i=0; i<prefix.length; i++)
            {
                if(prefix.length>4)
                {
                     if(i == prefix.length-1 || i == prefix.length-2 || i == prefix.length-3)
                     {
                        maskid = maskid + prefix[i].toString();
                      }
                else {
                        maskid = maskid + "*";
                    }
                 }
            else{
                     if(i == prefix.length-1)
                     {
                        maskid = maskid + prefix[i].toString();
                      }
                else {
                        maskid = maskid + "*";
                    }
                 }

            }
            maskid =maskid +postfix;

          }
           var rcv_otp_type = '';
           if(response.data.phone===''|| response.data.phone===null){
               rcv_otp_type = 'email';
           }

               this.setState({
                   form_view: true,
                   mobile:response.data.phone,
                   maskedEmail:maskid,
                   subgroup_id:response.data.subgroup_id,
                   rcv_otp_type:rcv_otp_type
               })

           } else if (response.data.status == 'expired' || response.data.status == 'notexist'){
               this.setState({
                   err_message: true,
               })
            }
           else if(response.data.status=='google_login') {
               alert("Your Account has been Activated Please Login");
               window.location.href = "/";
           }
       });

   }
    onChangeOTP(e){
        this.setState({
            OTPVal: e.target.value
        })
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
        //console.log(this.state);
    }

    onSubmit(e) {
        e.preventDefault();
    if(this.state.rcv_otp_type=='')
    { alert("Please select OTP verification type");
     return false;
    }
        this.setState({
            loading: true,
            errors:''
        });
        const user = {
            email: this.state.email.trim(),
            password: this.state.password
        };

        let validate ='';
        if(this.state.OTP===false) {
            validate = this.validator.allValid();
        }
        else {
            validate = this.validator1.allValid();
        }

        // alert(user.email+','+user.password+','+this.state.OTPVal+','+this.state.uArray)

        if (validate) {
            axios.post(config.get('API_URL')+'/users/check_cred', {
                email: user.email,
                password: user.password,
                otp: this.state.OTPVal,
                otp_type:this.state.rcv_otp_type,
                uArray : this.state.uArray

            })
                .then(response => { //console.log("gdfgdfg"); console.log(response.data.responseDetails.requestType);

                    if(response.data.responseMessage == 'Invalid Parameters') {
                        this.setState({
                            errors: "Invalid Parameters",
                            loading: false
                        });
                        return false;
                    }
                    if(response.data.responseDetails.requestType == 'GENERATE_OTP') {
                        this.setState({
                            OTP: true,
                            loading: false,
                            mobile: response.data.responseDetails.mobileNumber,
                            countdown:Date.now()
                        })
                    }
                     else if(response.data.responseDetails.requestType == 'sendEmailWithAttachment') {
                        this.setState({
                            OTP: true,
                            loading: false,
                            countdown:Date.now()
                        })
                    }
                    else if(response.data.responseDetails.requestType == 'Error') {
                        console.log("error");
                        this.setState({
                            errors: response.data.responseDetails.error,
                            loading: false
                        })
                    } else if(response.data.responseDetails.requestType == 'activate') {
                        //console.log("sucess");
                        alert("Your Account has been Activated Please Login");
                        window.location.href = "/";

                        // console.log(decoded);
                        return response.data
                    }

                })
                .catch(err => {
                    //console.log(err);
                    //console.log(err.error);
                    localStorage.removeItem("usertoken");
                    localStorage.removeItem("userPermission");
                })
        } else {
            //alert("out");
            this.validator.showMessages();
            this.validator1.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            this.setState({
                loading: false
            });
        }
    }
    onTypeChanged(e){
        this.setState({rcv_otp_type:e.target.alt})
    }

    render() {
        const Completionist = () => <span className="otpError">OTP has been expired!</span>;
        const renderer = ({ hours, minutes, seconds, completed }) => {
            if (completed) {
                // Render a completed state
                return <Completionist />;
            } else {
                // Render a countdown
                return <span>{hours}:{minutes}:{seconds}</span>;
            }
        };
     var content = "";
     if(this.state.response_status=='notexist') {
         content = "User does't exist."
     } else if(this.state.response_status=='expired') {
        content = "Your activation link has been expired."
     }
     else if(this.state.response_status=='user_active') {
        alert("Your account is already active. Please Login");
        window.location.href = "/";
     }
    const leftBackground = {
        backgroundImage: "url(" + leftBackImg + ")"
    };
      return (
         <div className = "content-msg authFrom">
             <div className="col-md-6 col-sm-12 no-padd auth-left-background" style={leftBackground}>
                 <div className="welcome-text">
                     <h2>Welcome to Sparcs</h2>
                     <h5>Please activate your account</h5>
                 </div>
             </div>
             <div className="col-md-6 col-sm-12 no-padd auth-right-background">
                 {/*<h2 className="text-center authheading">*/}
                 {/*    <img src={invLogo} alt={invLogo} className="" />*/}
                 {/*</h2>*/}
                 <div className="login-card ">
                   <div>
                       <div className='sweet-loading'>
                       <BeatLoader
                           css={override}
                           sizeUnit={"px"}
                           size={10}
                           color={'#123abc'}
                           loading={this.state.loading1}
                       />
                       </div>
                       {this.state.form_view===true?
                           <form className="" method="POST" onSubmit={this.onSubmit}>
                               <div className="form-group">

                                   <Input placeholder="Enter Email/Mobile number" name="email" type="text" className="form-control logon-input"  value={this.state.email} onChange={this.onChange} />
                                   {this.validator.message('email', this.state.email, 'required')}
                               </div>
                               <div className="form-group">

                                   <Input placeholder="Enter your password" name="password" type="password" className="form-control logon-input" value={this.state.password} onChange={this.onChange}/>
                                   {this.validator.message('password', this.state.password, 'required')}
                               </div>
                             { !(this.state.mobile==="" || this.state.mobile===null)&&
                               <div>
                               <span className="red-text"> How would you like to receive the OTP?</span>
                                <div>
                                    <input type="radio"  name="otp_type" alt="phone" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'phone'}
                                           onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My Phone Number ******{this.state.mobile?this.state.mobile.substr(-4):this.state.mobile}</label>
                                </div>

                                   <div>
                                       <input type="radio"  name="otp_type"  alt="email" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'email'}
                                              onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My E-mail Address {this.state.maskedEmail}</label>
                                   </div>

                               </div>
                            }
                               {this.state.OTP===true?
                                   <div className="form-group">

                                       <div className="">
                                           <Input placeholder="Enter OTP" name="otp" type="text" className="form-control OTP-Text logon-input"  value={this.state.OTPVal} onChange={this.onChangeOTP.bind(this)} />
                                       </div>
                                       <div className="col-xs-12">
                                           <Countdown
                                               date={this.state.countdown + 300000}
                                               renderer={renderer}
                                           />
                                       </div>

                                     { this.state.rcv_otp_type=="phone"?
                                     <div className="col-xs-12">
                                           <small className="otpMessage text-muted">A SMS verification code send to your register mobile number ******{this.state.mobile.substr(-4)} please verify your account.</small>
                                       </div>
                                       :
                                      <div className="col-xs-12">
                                           <small className="otpMessage text-muted">A verification code send to your register email ID {this.state.maskedEmail} please verify your account.</small>
                                       </div>
                                       }

                                       <div className="clearfix"></div>

                                       {this.validator1.message('One Time Password', this.state.OTPVal, 'required')}
                                       {/*<div className="otpMessage">A SMS varification code send to your register mobile number ******{this.state.mobile.substr(-4)} please verify your account.</div>*/}
                                   </div>

                                   : null  }

                               <div className="form-group">
                                   <span className ="errmsg">{this.state.errors}</span>
                                       <button
                                           type="submit"
                                           className="btn btn-lg btn-primary btn-block btn-login"
                                       >
                                           Submit
                                       </button>

                               </div>
                               <br/>
                               <div className='sweet-loading'>
                                   <BeatLoader
                                       css={override}
                                       sizeUnit={"px"}
                                       size={10}
                                       color={'#123abc'}
                                       loading={this.state.loading}
                                   />
                               </div>

                           </form> :
                           <div className="acivation_err">{content}</div>
                       }

                   </div>
               </div>
            </div>
            <div className="clearfix"></div>
         </div>


      );
    }
  }

  export default ActivateAccount;